import { lastActivity, lastSeen } from '~/helpers/fields-description';
import { rfStatus } from '~/helpers/network-fields-description';
import { FieldObject } from '~/interfaces/field.interface';
import { NAModule } from '~/models/modules/NAModule.model';

export class VeluxModule extends NAModule {
    hasOperationImportData = false;
    hasOperationDissociate = false;
    hasOperationReset = false;

    rf_status?: number;
    last_activity?: number;

    get fieldLastActivity(): FieldObject {
        return lastActivity(this.last_activity);
    }
    get fieldRfStatus(): FieldObject {
        return rfStatus(this.getRfIcon(this.rf_status), this.rf_status);
    }
    get fieldLastSeen(): FieldObject {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
}
